import { createFileRoute } from '@tanstack/react-router'

import { SendTransaction } from '../-components/SendTransaction.js'
import * as RemoteRpc from '../-lib/RemoteRpc.js'

export const Route = createFileRoute('/remote/rpc/eth_sendTransactionSync')({
  component: Component,
  validateSearch: (search) =>
    RemoteRpc.validateSearch(search, { method: 'eth_sendTransactionSync' }),
})

function Component() {
  const search = Route.useSearch()
  return <SendTransaction request={search} />
}
